<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <sidebar-component classMenu="DashboardFullfilment"></sidebar-component>
      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div
                class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
              >
                <div class="col-lg-2 col-xl-3 col-sm-3 col-xs-3 col-md-3">
                  <h4 class="mb-3 mb-md-0">Report Fppk</h4>
                </div>
                <div class="col-lg-10 col-xl-9 col-sm-9 col-xs-9 col-md-9">
                  <div class="d-flex flex-wrap">
                    <div
                      class="input-group flatpickr wd-250 me-2 mb-2 mb-md-0"
                      id="dashboardDate"
                    >
                      <date-range-picker
                        style="width: 100%"
                        @change="loadData"
                        control-container-class="form-control"
                        :locale-data="locale"
                        v-model="dateFilter"
                        :opens="opens"
                        :singleDatePicker="false"
                        :timePicker24Hour="true"
                        :timePicker="true"
                        :showWeekNumbers="false"
                      >
                      </date-range-picker>
                    </div>
                    <button
                      type="button"
                      style="max-height: 40px"
                      @click.prevent="loadData"
                      class="btn btn-primary btn-icon-text mb-2 mb-md-0 btn-block btn-floating"
                    >
                      GO
                    </button>
                    <span style="width: 5px"> </span>
                    <button
                      class="btn btn-success btn-icon-text btn-block"
                      style="margin-right: 5px; max-height: 40px"
                      @click.prevent="downloadData()"
                    >
                      Download
                    </button>
                    
                    <!-- <span style="width: 5px"> </span>
                    <button
                      class="btn btn-success btn-icon-text btn-block"
                      style="margin-right: 5px; max-height: 40px"
                      @click.prevent="downloadData()"
                    >
                      Download
                    </button>
                    <button
                      class="btn btn-secondary btn-icon-text btn-block"
                      style="margin-right: 5px; max-height: 40px"
                      @click.prevent="downloadDataDetail()"
                    >
                      Download Detail Fulfillment
                    </button> -->
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-12" style="height: 500px">
                      <Bar
                        :chart-options="chartOptions"
                        :chart-data="chartDataLine"
                        :chart-id="chartId"
                        :dataset-id-key="datasetIdKey"
                        :plugins="plugins"
                        :css-classes="cssClasses"
                        :styles="myStyles"
                        :width="width"
                        :height="height"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
    <modal-fppk-detail
      :showModal="showModalDetail"
      :data="detailData"
      @closeModal="closeMyModal"
    ></modal-fppk-detail>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from "vue2-daterange-picker";
import modalFppkKanbanDetail from "@/components/modal/modalFppkKanbanDetail.vue";

import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

import moment from "moment";

export default {
  props: {
    chartId: {
      type: String,
      default: "bar",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Object,
      default: () => {},
    },
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 200,
    },
  },
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DateRangePicker,
    "modal-fppk-detail": modalFppkKanbanDetail,

    Bar,
  },
  data() {
    const startDate = moment().subtract(1,"month").format("YYYY-MM-DD");
    const endDate = moment().format("YYYY-MM-DD");
    return {
      chartOptions: {
        scales: {
          y: {
            stacked: true,
            ticks: {
              beginAtZero: true,
              min: 0,
              stepSize: 5,
            },
            gridLines: {
              display: true,
            },
          },
          x: {
            stacked: true,
            gridLines: {
              display: false,
            },
          },
        },
        legend: {
          display: true,
          position: "left",
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: (c, i) => {
          var labelDate = c.chart.config._config.data.labels[i[0].index];

          var label = this.chartDataLine.datasets[i[0].datasetIndex].label;
          this.clickDetailModal(label, labelDate);
        },
      },
      isLoading: false,
      chartDataLine: {
        labels: [],
        datasets: [],
      },
      label: {},
      data: [],
      dataSets: [],
      dateFilter: {
        startDate,
        endDate,
      },
      locale: {
        format: "yyyy-mm-dd",
      },
      opens: "center",
      showModalDetail: false,
      detailData: {},
    };
  },
  computed: {
    myStyles() {
      return {
        height: "100%",
        position: "relative",
      };
    },
  },
  methods: {

    downloadData() {
        this.isLoading = true;
        const baseURI = this.$settings.endPointFppk + "v1/report-fppk/on-demand-report";
        var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
        var file_name = "download_" + CurrentDate + ".xlsx";
       

        let dataSend = {
          start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'), //this.dateFilter.startDate,  // moment(String(this.forms.join_date)).format('YYYY-MM-DD');
          end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
          // end: this.dateFilter.endDate,                
        };

        var tanggal_submit=dataSend.start+'~'+dataSend.end;
  
        return this.$http
          .get(
            baseURI +
            `?tanggal_submit=${tanggal_submit}&download=download`,
            {
              responseType: "blob",
            }
          )
          .then((response) => {
  
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
  
            fileLink.href = fileURL;
            fileLink.setAttribute("download", file_name);
            document.body.appendChild(fileLink);
            fileLink.click();
            this.fade(false);
          });
    },

    loadData() {
      // console.log("Triggered");
      let dataSend = {
        start: moment(String(this.dateFilter.startDate)).format("YYYY-MM-DD"),
        end: moment(String(this.dateFilter.endDate)).format("YYYY-MM-DD"),
      };
      const baseURI =
        this.$settings.endPointFppk +
        "v1/report-fppk/kanban?start=" +
        dataSend.start +
        "&end=" +
        dataSend.end;
      this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.isLoading = false;
          if (response.status == 200) {
            var labelstemp = Object.keys(response.data.datas);
            delete labelstemp[labelstemp.length - 1];
            this.dataSets = [];
            labelstemp.forEach((datas) => {
              var data = {
                label: datas.toUpperCase().replace("_", " ").toUpperCase().replace("_", " "),
                // borderColor: this.generateColor(datas),
                pointBackgroundColor: "white",
                pointBorderColor: "white",
                borderWidth: 1,
                // backgroundColor: this.getRandomColorHexRgbA(),
                backgroundColor: this.generateColor(),
                data: response.data.datas[datas],
              };
              this.dataSets.push(data);
            });
            this.labels = response.data.datas["date"];
            this.chartDataLine = {
              labels: this.labels,
              datasets: this.dataSets,
            };

            console.log(this.dataSets);
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.error(error.response.data.errors.message);
              } else {
                //this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    clickDetailModal(label, labelDate) {
      this.showModalDetail = true;
      this.detailData = {
        status_fppk: label,
        tanggal_submit: labelDate,
      };
    },
    generateColor() {
      return "#" + Math.floor(Math.random() * 16777215).toString(16);
    },
    getRandomColorHexRgbA() {
      var r = Math.floor(Math.random() * 255);
      var g = Math.floor(Math.random() * 255);
      var b = Math.floor(Math.random() * 255);
      return "rgba(" + r + "," + g + "," + b + ",0.2)";
    },
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "ReportFppkController") {
          rolePermision = permision;
        }
      });

      // if (!rolePermision.method_custom1) {
      //   this.$router.push("/authorized-error");
      // }

      this.permision_role = rolePermision;
    },
    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
    closeMyModal() {
      this.showModalDetail = false;
    },
  },
  mounted() {
    this.fetchIt();
    this.loadData();
    setInterval(() => {
      this.loadData();
    }, 300000);
  },
};
</script>

<style>
</style>